import React, { useState } from 'react';
import { AuthorizedPage } from '../auth/AuthorizedPage';
import { Page } from '../components/Page';
import { PageContent } from '../components/PageContent';
import { FlexTableBox } from '../components/FlexTableBox';
import { LoadingState } from '../components/LoadingStateUtil';
import { FulfillmentPlansGrid } from '../fulfillmentPlan/FulfillmentPlansGrid';
import useMemoTranslation from '../hooks/UseMemoTranslation';

export const FulfillmentPlanPage = () => {
  const { t } = useMemoTranslation();
  const [loadingState, setLoadingState] = useState<LoadingState>({ status: 'Loading' });

  return (
    <AuthorizedPage requireAny hasGreenSideViewAccess hasSampleTrackingViewAccess>
      <Page title={t('fulfillmentPlans')}>
        <PageContent>
          <FlexTableBox>
            <FulfillmentPlansGrid loadingProps={[loadingState, setLoadingState]} />
          </FlexTableBox>
        </PageContent>
      </Page>
    </AuthorizedPage>
  );
};
